/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Project import completed successfully" |
*
* @param {Iconik_Import_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_success_toast = /** @type {((inputs?: Iconik_Import_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du projet terminee avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektimport erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del progetto completata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт проекта успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La importación del proyecto se completó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目导入已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポートが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट का आयात सफलतापूर्वक पूरा हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação do projeto concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Project import completed successfully")
});